"use client";

import { useState, type ReactNode } from "react";
import Link from "next/link";
import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

const NAV_LINKS = [
  { label: "Semua Ujian", href: "/ujian" },
  { label: "Blog", href: "/blog" },
  { label: "Coba Demo", href: "/coba" },
];

/** Mobile hamburger menu (slide-in Sheet) for the landing navbar.
 * Shows nav links + the auth slot (server-rendered di landing-navbar,
 * "fresh behind Suspense") that are hidden on mobile (<lg) in the desktop navbar.
 * Navigasi antar-route meng-unmount halaman landing → sheet tertutup sendiri,
 * jadi slot tidak butuh handler close. */
export function LandingMobileNav({ authSlot }: { authSlot: ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger
        render={
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            aria-label="Buka menu navigasi"
          >
            <Menu size={22} />
          </Button>
        }
      />
      <SheetContent side="right" className="w-72">
        <SheetHeader>
          <SheetTitle>Menu</SheetTitle>
        </SheetHeader>
        <nav className="flex flex-col gap-1 px-4" aria-label="Navigasi mobile">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-foreground/70 hover:bg-muted hover:text-primary rounded-lg px-4 py-3 text-sm font-bold transition-colors"
            >
              {l.label}
            </Link>
          ))}
          <div className="border-border/60 mt-4 flex flex-col gap-2 border-t pt-4">
            {authSlot}
          </div>
        </nav>
      </SheetContent>
    </Sheet>
  );
}
